import { render, staticRenderFns } from "./RoutinesSection.vue?vue&type=template&id=2ce822f8&scoped=true"
import script from "./RoutinesSection.vue?vue&type=script&lang=js"
export * from "./RoutinesSection.vue?vue&type=script&lang=js"
import style0 from "./RoutinesSection.vue?vue&type=style&index=0&id=2ce822f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce822f8",
  null
  
)

export default component.exports